import { render } from "./SearchHistory.vue?vue&type=template&id=234f54c1&scoped=true&ts=true&class=fadein_serch"
import script from "./SearchHistory.vue?vue&type=script&lang=ts"
export * from "./SearchHistory.vue?vue&type=script&lang=ts"

import "./SearchHistory.vue?vue&type=style&index=0&id=234f54c1&scoped=true&lang=css"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234f54c1"]])

export default __exports__